import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components/layout/PageContainer';

export function SignupSuccessPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <PageContainer>
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
          <div className="mb-8">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-[#222222] mb-4">회원가입 완료!</h1>
            <p className="text-base text-[#606060] mb-2">
              에코딜에 오신 걸 환영합니다.
            </p>
            <p className="text-base text-[#606060] mb-6">
              이제 바로 할인 상품을 확인하고 단골 매장을 등록해 보세요.
            </p>
            <div className="bg-[#F5F5F5] rounded-lg p-4 mb-6 text-left max-w-md mx-auto">
              <p className="text-sm text-[#222222] font-medium mb-2">이제 이런 것부터 시작해 보세요</p>
              <ul className="text-sm text-[#606060] space-y-1">
                <li>• 홈에서 오늘의 마감 할인 상품을 확인해 보세요</li>
                <li>• 마이페이지에서 추천 코드를 확인해 친구와 함께 혜택을 받아보세요</li>
                <li>• 단골 가게를 등록하면 빠르게 재주문할 수 있어요</li>
              </ul>
            </div>
            <button
              onClick={() => navigate('/')}
              className="w-full max-w-md h-[44px] bg-[#51C854] text-white font-semibold text-lg rounded-xl hover:bg-[#46B649] transition-colors"
            >
              홈페이지로 이동
            </button>
          </div>
        </div>
      </PageContainer>
    </div>
  );
}
